"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbHeading = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const core_1 = require("@material-ui/core");
const Breadcrumb_context_1 = require("./Breadcrumb.context");
const Breadcrumb_hooks_1 = require("./Breadcrumb.hooks");
/**
 * Displays the current breadcrumb in the context
 */
const BreadcrumbHeading = ({ breadcrumb }) => {
    const { breadcrumbs } = (0, react_1.useContext)(Breadcrumb_context_1.BreadcrumbContext);
    const { setBreadcrumb } = (0, Breadcrumb_hooks_1.useBreadcrumb)(breadcrumb);
    const breadcrumbRef = (0, react_1.useRef)(breadcrumb);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        // check breadcrumb props against previous value to determine if any
        // changes occurred and if so notify the breadcrumb context to refresh
        if (((_a = breadcrumbRef.current) === null || _a === void 0 ? void 0 : _a.label) !== (breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.label) ||
            ((_b = breadcrumbRef.current) === null || _b === void 0 ? void 0 : _b.path) !== (breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.path)) {
            breadcrumbRef.current = breadcrumb;
            setBreadcrumb(breadcrumb);
        }
    }, [breadcrumb, setBreadcrumb]);
    return (react_1.default.createElement(core_1.Breadcrumbs, { "aria-label": 'breadcrumb' }, breadcrumbs.map(breadcrumb => (react_1.default.createElement("h1", { key: `${breadcrumb.label}::${breadcrumb.path}` }, breadcrumb.path ? (react_1.default.createElement(react_router_dom_1.Link, { color: 'inherit', to: breadcrumb.path }, breadcrumb.label)) : (breadcrumb.label))))));
};
exports.BreadcrumbHeading = BreadcrumbHeading;
exports.default = exports.BreadcrumbHeading;
//# sourceMappingURL=BreadcrumbHeading.js.map